// Chakra imports
import { Box, Flex, Text, useColorModeValue, Icon} from "@chakra-ui/react";
import { IoCheckmarkDoneCircleSharp } from "react-icons/io5";
// Custom components
import Card from "./../../../../components/Card/Card.js";
import CardHeader from "./../../../../components/Card/CardHeader.js";
import React from "react";
import LineChart from "./../../../../components/Charts/LineChart";

const LeadsCurrentWeek = ({ data }) => {

  const dates = data.map(item => item.date).reverse();
  const leadCount = data.map(item => item.count).reverse();
  const leadTotalCount = data.reduce((accumulator, item) => accumulator + item.count, 0);

   const lineChartDataDefault = [
    {
      name: "Leads",
      data: leadCount,
    }
  ];
  
   const lineChartOptionsDefault = {
    chart: {
      toolbar: {
        show: false,
      },
    },
    tooltip: {
      theme: "dark",
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    xaxis: {
      type: "datetime",
      categories: dates,
      labels: {
        style: {
          colors: "#c8cfca",
          fontSize: "12px",
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: "#c8cfca",
          fontSize: "12px",
        },
      },
    },
    legend: {
      show: false,
    },
    grid: {
      strokeDashArray: 5,
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "vertical",
        shadeIntensity: 0.5,
        gradientToColors: undefined, // optional, if not defined - uses the shades of same color in series
        inverseColors: true,
        opacityFrom: 0.8,
        opacityTo: 0,
        stops: [],
      },
      colors: ["#4FD1C5", "#2D3748"],
    },
    colors: ["#4FD1C5", "#2D3748"],
  };



  const textColor = useColorModeValue("gray.700", "white");
  return (
    <Card p='28px 10px 16px 0px' mb={{ sm: "26px", lg: "0px" }}>
      <CardHeader mb='20px' pl='22px'>
        <Flex direction='column' alignSelf='flex-start'>
          <Text fontSize='lg' color={textColor} fontWeight='bold' mb='6px'>
            Leads pr. dag seneste uge
          </Text>
          <Flex align='center'>
            <Icon
              as={IoCheckmarkDoneCircleSharp}
              color='teal.300'
              w={8}
              h={8}
              pe='3px'
            />
            Antal leads ialt: {leadTotalCount}
          </Flex>
        </Flex>
      </CardHeader>
      <Box w='100%' h={{ sm: "300px" }} ps='8px'>
        <LineChart
              chartData={lineChartDataDefault}
              chartOptions={lineChartOptionsDefault}
            />
      </Box>
    </Card>
  );
};

export default LeadsCurrentWeek;
